<template>
  <div class="dbc-gl-page" :class="[runtimeConfig.public.client]">
    <div class="dbc-gl-content">
      <component
        v-for="content in page?.content"
        :is="componentMap[content.__component]"
        :key="content.__component"
        :content="content"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
const route = useRoute()
const runtimeConfig = useRuntimeConfig()
const componentMap = useContentComponents()

const { data: page } = await useFetch<Page>(`/api/pages`, {
  baseURL: runtimeConfig.public.cms,
  query: {
    populate: 'deep',
    locale: `${route.params.locale}`,
    'filters[path][$eq]': `${route.params.route}`,
  },
  onResponse({ response }) {
    response._data = response._data.data[0]
    return response._data
  },
  deep: false,
})

if (!page.value) {
  throw createError({
    statusCode: 500,
    statusMessage: `Page ${route.fullPath} is empty`,
  })
}

useHead({
  htmlAttrs: {
    class: 'webview',
  },
})
</script>
